import * as api from '../resources/media-templates.api';

const PERCENT_MULTIPLIER = 100;

const FETCH_MEDIA_TEMPLATE_REQUEST = 'FETCH_MEDIA_TEMPLATE_REQUEST';
const FETCH_MEDIA_TEMPLATE_SUCCESS = 'FETCH_MEDIA_TEMPLATE_SUCCESS';
const FETCH_MEDIA_TEMPLATE_FAILURE = 'FETCH_MEDIA_TEMPLATE_FAILURE';
const FETCH_FONTS_REQUEST = 'FETCH_FONTS_REQUEST';
const FETCH_FONTS_SUCCESS = 'FETCH_FONTS_SUCCESS';
const FETCH_FONTS_FAILURE = 'FETCH_FONTS_FAILURE';
const UPDATE_MEDIA_TEMPLATE_REQUEST = 'UPDATE_MEDIA_TEMPLATE_REQUEST';
const UPDATE_MEDIA_TEMPLATE_SUCCESS = 'UPDATE_MEDIA_TEMPLATE_SUCCESS';
const UPDATE_MEDIA_TEMPLATE_FAILURE = 'UPDATE_MEDIA_TEMPLATE_FAILURE';
const PREVIEW_MEDIA_TEMPLATE_REQUEST = 'PREVIEW_MEDIA_TEMPLATE_REQUEST';
const PREVIEW_MEDIA_TEMPLATE_SUCCESS = 'PREVIEW_MEDIA_TEMPLATE_SUCCESS';
const PREVIEW_MEDIA_TEMPLATE_FAILURE = 'PREVIEW_MEDIA_TEMPLATE_FAILURE';

export const fetchMediaTemplateRequest = () => ({
  type: FETCH_MEDIA_TEMPLATE_REQUEST,
  isLoading: true,
});

export const fetchMediaTemplateSuccess = (entries) => ({
  type: FETCH_MEDIA_TEMPLATE_SUCCESS,
  isLoading: false,
  entries,
});

export const fetchMediaTemplateFailure = () => ({
  type: FETCH_MEDIA_TEMPLATE_FAILURE,
  isLoading: false,
});

export const fetchMediaTemplate = (posterName) => async (dispatch) => {
  try {
    dispatch(fetchMediaTemplateRequest());
    const entries = await api.fetchMediaTemplate(posterName);
    transformEntriesForUI(entries);
    dispatch(fetchMediaTemplateSuccess(entries));
  } catch (error) {
    console.error('FETCH_MEDIA_TEMPLATE', error);
    dispatch(fetchMediaTemplateFailure());
  }
};

export const fetchFontsRequest = () => ({
  type: FETCH_FONTS_REQUEST,
  isLoading: true,
});

export const fetchFontsSuccess = (fonts) => ({
  type: FETCH_FONTS_SUCCESS,
  isLoading: false,
  fonts,
});

export const fetchFontsFailure = () => ({
  type: FETCH_FONTS_FAILURE,
  isLoading: false,
});

export const fetchFonts = () => async (dispatch) => {
  try {
    dispatch(fetchFontsRequest());
    const fonts = await api.fetchFonts();
    dispatch(fetchFontsSuccess(fonts));
  } catch (error) {
    console.error('FETCH_FONTS', error);
    dispatch(fetchFontsFailure());
  }
};

export const transformEntriesForUI = (entries) => entries.map((entry) => transformEntryForUI(entry));

const transformEntryForUI = (entry) => {
  entry.scale *= PERCENT_MULTIPLIER;
  return entry;
};

export const updateMediaTemplateRequest = () => ({
  type: UPDATE_MEDIA_TEMPLATE_REQUEST,
  isSaving: true,
});

export const updateMediaTemplateSuccess = () => ({
  type: UPDATE_MEDIA_TEMPLATE_SUCCESS,
  isSaving: false,
  error: false,
});

export const updateMediaTemplateFailure = () => ({
  type: UPDATE_MEDIA_TEMPLATE_FAILURE,
  isSaving: false,
  error: true,
});

export const updateMediaTemplate = (entries) => async (dispatch) => {
  try {
    dispatch(updateMediaTemplateRequest());
    transformEntriesForSave(entries);
    await api.updateMediaTemplate(entries);
    dispatch(updateMediaTemplateSuccess());
  } catch (error) {
    console.error('UPDATE_MEDIA_TEMPLATE', error);
    dispatch(updateMediaTemplateFailure());
  }
};

export const previewMediaTemplateRequest = () => ({
  type: PREVIEW_MEDIA_TEMPLATE_REQUEST,
  isPreviewing: true,
});

export const previewMediaTemplateSuccess = () => ({
  type: PREVIEW_MEDIA_TEMPLATE_SUCCESS,
  isPreviewing: false,
  error: false,
});

export const previewMediaTemplateFailure = () => ({
  type: PREVIEW_MEDIA_TEMPLATE_FAILURE,
  isPreviewing: false,
  error: true,
});

export const previewMediaTemplate = (posterConfig, posterParams) => async (dispatch) => {
  try {
    dispatch(previewMediaTemplateRequest());
    transformEntryForSave(posterConfig);
    const previewData = {
      posterConfig,
      posterParams,
    };
    const data = await api.previewMediaTemplate(previewData);

    const file = new Blob([data], { type: 'application/pdf' });
    window.saveAs(file, 'preview.pdf');

    dispatch(previewMediaTemplateSuccess());
  } catch (error) {
    console.error('PREVIEW_MEDIA_TEMPLATE', error);
    dispatch(previewMediaTemplateFailure());
  }
};

export const transformEntriesForSave = (entries) => entries.map((entry) => transformEntryForSave(entry));

const transformEntryForSave = (entry) => {
  entry.scale /= PERCENT_MULTIPLIER;
  if (entry.image && entry.image.length > 0) {
    const image = entry.image.pop();
    if (image.fileSource) {
      entry.imageFile = image.fileSource;
      entry.imageUrl = null;
    }
  } else {
    entry.imageFile = null;
    entry.imageUrl = null;
  }
  delete entry.image;
  return entry;
};

export default {
  FETCH_MEDIA_TEMPLATE_REQUEST,
  FETCH_MEDIA_TEMPLATE_SUCCESS,
  FETCH_MEDIA_TEMPLATE_FAILURE,
  FETCH_FONTS_REQUEST,
  FETCH_FONTS_SUCCESS,
  FETCH_FONTS_FAILURE,
  UPDATE_MEDIA_TEMPLATE_REQUEST,
  UPDATE_MEDIA_TEMPLATE_SUCCESS,
  UPDATE_MEDIA_TEMPLATE_FAILURE,
  PREVIEW_MEDIA_TEMPLATE_REQUEST,
  PREVIEW_MEDIA_TEMPLATE_SUCCESS,
  PREVIEW_MEDIA_TEMPLATE_FAILURE,
};



// WEBPACK FOOTER //
// ./src/modules/app/actions/media-templates.actions.js